import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// CONTEXT
import { AuthContext } from 'context/AuthContext';
import { ToastContext } from 'context/ToastContext';

// COMPONENTS
import Loader from './loaderComponent';

function ProtectedRoute({ children, adminOnly = false }) {
    const { addToast } = useContext(ToastContext);
    const navigate = useNavigate();
    const { authenticated, isAdmin, loading } = useContext(AuthContext);

    useEffect(() => {
        if (!loading) {
            if (!authenticated) {
                addToast(
                    "Accès refusé",
                    "Vous devez être connecté pour accéder à cette page.",
                    null,
                    null,
                    "error"
                );
                navigate('/', { replace: true });
            } else if (adminOnly && !isAdmin) {
                addToast(
                    "Accès refusé",
                    "Vous n'avez pas les droits administrateur nécessaires pour accéder à cette page.",
                    null,
                    null,
                    "error"
                );
                navigate('/error', { 
                    state: { 
                        title: "Accès Refusé", 
                        message: "Vous n'avez pas les droits administrateur nécessaires pour accéder à cette page." 
                    } 
                });
            }
        }
    }, [loading, authenticated, isAdmin, navigate, adminOnly, addToast]);

    if (loading) {
        return <Loader />;
    }

    if (!authenticated || (adminOnly && !isAdmin)) {
        return null;
    }

    return children;
}

export default ProtectedRoute;